import Model from './Model'

export default class Notification extends Model {
  resource() {
    return 'notifications'
  }
}
